import axios from 'axios';
import { getACMHeaders } from './acm-helpers';

const SIGNED_S3_DOWNLOAD_SUFFIX = 'signeds3download';
const SIGNED_S3_UPLOAD_SUFFIX = 'signeds3upload';

const getS3Url = ({ url, token, projectScope, isUpload = false }) => {
  const s3RedirectSuffix = isUpload ? SIGNED_S3_UPLOAD_SUFFIX : SIGNED_S3_DOWNLOAD_SUFFIX; // https://wiki.autodesk.com/pages/viewpage.action?spaceKey=FDPA&title=API+Endpoints#APIEndpoints-GetDownloadURL
  const getSignedS3Url = `${url}/${s3RedirectSuffix}`;

  return axios
    .request({
      url: getSignedS3Url,
      method: 'GET',
      headers: {
        ...getACMHeaders(projectScope),
        ...(token && { Authorization: `Bearer ${token}` }),
        'Content-Type': 'application/json',
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const getS3DownloadUrl = ({ url, token, projectScope }) => {
  return getS3Url({ url, token, projectScope, isUpload: false });
};
export const getS3UploadUrl = ({ url, token, projectScope }) => {
  return getS3Url({ url, token, projectScope, isUpload: true });
};

export const uploadFileToS3 = ({ url, file, fileId, projectScope, onUploadProgress }) => {
  const data = new File([file], fileId);
  return axios.request({
    url,
    method: 'PUT',
    headers: {
      ...getACMHeaders(projectScope),
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: '*/*',
    },
    onUploadProgress,
    data,
  });
};

// https://wiki.autodesk.com/pages/viewpage.action?spaceKey=FDPA&title=API+Endpoints#APIEndpoints-CompleteUpload
export const completeUploadFileToS3 = ({ url, eTags, uploadKey, token }) => {
  const signedUrl = `${url}/${SIGNED_S3_UPLOAD_SUFFIX}`;
  return axios.request({
    url: signedUrl,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      uploadKey,
      eTags,
    },
  });
};
